import type { CMSConfig } from '#types/config/components/cms'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    content: 'space-y-1 lg:(p-6 -m-6)',
    contentContainer: 'relative h-inherit w-full flex px-6 py-10',
    contentCtaContainer: 'gap-2 not-first:pt-3',
    contentCtaContainerInner: 'flex gap-2 wrap'
  }
} satisfies RecursivePartial<CMSConfig['hero']>
